import { motion } from 'motion/react';
import { ModalBox, ModalBoxProps } from '../atoms';

export const CenteredModalBox = ({ children, ...rest }: ModalBoxProps) => {
  return (
    <motion.div
      initial={{
        opacity: 0,
        y: '50%',
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      exit={{
        opacity: 0,
        y: '50%',
      }}
      transition={{
        type: 'spring',
        damping: 24,
        stiffness: 300,
      }}
    >
      <ModalBox {...rest}>{children}</ModalBox>
    </motion.div>
  );
};
